import React from "react";
import GuestHeader from "../Headers/GuestHeader";
import Footer from "../Footer/Footer";

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <GuestHeader />
      {children}
      <Footer />
    </>
  );
};

export default MainLayout;
